var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabsDisActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7,
    fill: "#C1C3C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5454 10.3375L16.2575 8.70783L15.9859 8.25579C15.836 8.00632 15.5119 7.92535 15.2623 8.07536L13.4541 9.16176C13.2046 9.31167 13.1237 9.63577 13.2737 9.88538L13.5454 10.3375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4559 20.3073C24.3047 20.0584 23.9802 19.9789 23.7313 20.1301L20.7884 21.9178C20.9283 22.2535 21.0194 22.6139 21.0535 22.9908L24.2787 21.0315C24.5279 20.8803 24.607 20.5562 24.4559 20.3073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5963 24.9454H20.0143V23.3282C20.0143 21.8743 18.8315 20.6915 17.3776 20.6915C15.9237 20.6915 14.7409 21.8743 14.7409 23.3282V24.9454H13.1588C12.8676 24.9454 12.6315 25.1815 12.6315 25.4727C12.6315 25.7639 12.8676 26 13.1588 26H21.5963C21.8876 26 22.1237 25.7639 22.1237 25.4727C22.1237 25.1815 21.8876 24.9454 21.5963 24.9454ZM17.3776 23.8555C17.0864 23.8555 16.8503 23.6194 16.8503 23.3282C16.8503 23.0369 17.0864 22.8008 17.3776 22.8008C17.6688 22.8008 17.9049 23.0369 17.9049 23.3282C17.9049 23.6194 17.6688 23.8555 17.3776 23.8555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4562 12.2367L14.0125 13.1625L15.1373 12.4824C16.4706 11.6762 18.1895 12.1255 18.9807 13.4187C19.7949 14.7498 19.3681 16.4863 18.0293 17.2881L16.8983 17.9654L17.2586 18.565C17.4092 18.8156 17.7348 18.8953 17.9838 18.7445C18.0004 18.7345 18.1769 18.6284 18.4435 18.4683L19.2525 19.8147C19.4027 20.0648 19.7272 20.1448 19.9761 19.9952L21.7842 18.9088C22.0339 18.7588 22.1146 18.4348 21.9646 18.1851L21.1556 16.8387C21.4255 16.6765 21.5984 16.5726 21.5984 16.5726C21.8481 16.4226 21.9288 16.0986 21.7788 15.849C21.7663 15.828 17.9729 9.51382 17.9591 9.49368C17.8012 9.2639 17.4918 9.19668 17.2528 9.34029L13.6366 11.5131C13.387 11.6631 13.3062 11.987 13.4562 12.2367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6862 23.3282C13.6862 22.2962 14.112 21.362 14.797 20.6915H14.2135C13.3412 20.6915 12.6315 19.9818 12.6315 19.1095C12.6315 18.2371 13.3412 17.5274 14.2133 17.5274C14.2136 17.5274 15.4303 17.528 15.4302 17.528C15.5257 17.5279 15.6193 17.5021 15.7012 17.453L17.4873 16.3833C18.3226 15.8831 18.589 14.7996 18.081 13.9691C17.58 13.1503 16.5043 12.8884 15.683 13.3849L14.0621 14.3651C11.5149 14.445 9.46744 16.5426 9.46744 19.1095C9.46744 21.5482 11.3164 23.5629 13.6862 23.8261V23.3282Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabsDisActive);
export default __webpack_public_path__ + "static/media/LabsDisActive.8bb7bb790b669d26c19d85f2352fc114.svg";
export { ForwardRef as ReactComponent };